import React from "react";
import ScaledMemo from "../components/ScaledMemo";

const SAMPLE = {
  invoice_no: "১০২৪",
  date: "2026-06-12",
  customer: { name: "মোঃ করিম উদ্দিন", mobile: "01712345678", address: "স্টেশন রোড, রংপুর" },
  items: [
    { name: "কপার তার ২.৫ মিমি (বিআরবি)", qty: 5, unit: "কয়েল", rate: 1200, total: 6000 },
    { name: "এলইডি বাল্ব ১২ ওয়াট", qty: 10, unit: "পিস", rate: 150, total: 1500 },
    { name: "সুইচ বোর্ড ৪ গ্যাং", qty: 3, unit: "পিস", rate: 320, total: 960 },
  ],
  subtotal: 8460,
  discount_amount: 460,
  grand_total: 8000,
  previous_due: 1500,
  paid: 5000,
  current_due: 4500,
  note: "",
};

export default function MemoSample() {
  return (
    <div className="min-h-screen bg-slate-200 p-6">
      <div className="max-w-[820px] mx-auto">
        <ScaledMemo memo={SAMPLE} />
      </div>
    </div>
  );
}
